export type SupplierOption = {
  name: string;
  supplierId: string;
};

export const supplierOptions = [
  {
    name: 'Øland Kraftvarmeværk',
    supplierId: 'ECC2B6AA-D579-498B-B396-D2D6EC2D6F22',
  },
  {
    name: 'Ølgod Fjernvarmeselskab / Ølgod Vandværk',
    supplierId: '0B32D29C-78CA-41C9-A735-1CD1DA07D1FC',
  },
  {
    name: 'Ørnhøj-Grønbjerg Kraftvarmeværk A.m.b.a',
    supplierId: '84124F7A-A498-4108-B7B3-629093679E9C',
  },
  {
    name: 'Ørsted Fjernvarmeværk',
    supplierId: 'DAAF0E75-5D4E-42B3-B891-B807111C0759',
  },
  {
    name: 'Ørum Varmeværk',
    supplierId: '885A57C3-D133-4FF3-9D95-EF6654FD40D5',
  },
  {
    name: 'Østbirk Varmeværk',
    supplierId: 'E80DAB4D-5336-4953-A141-461B06681349',
  },
  {
    name: 'Øster Hornum Varmeværk',
    supplierId: 'F914511C-C5C7-486F-B3B7-404416570A52',
  },
  {
    name: 'Øster Hurup Fjernvarme amba',
    supplierId: 'FDA7BB8C-7507-48C8-9667-0222A1E34E6A',
  },
  {
    name: 'Øster Toreby Varmeværk',
    supplierId: '51B65EF1-2661-4ABC-84AC-373A0FC023A1',
  },
  {
    name: 'Østerby Vand',
    supplierId: 'F9FAD66D-1FE1-4865-B331-DC03C8F74917',
  },
  {
    name: 'Østervrå Varmeværk',
    supplierId: '3247DB31-6045-4A32-92DD-7E2EB337001B',
  },
  {
    name: 'Østrup Vandværk',
    supplierId: 'FAF25ACA-5352-4AF9-8D83-722CE4D9E92F',
  },
  {
    name: 'ÅÅ_AF',
    supplierId: '0B6E2787-8B29-4EB3-8704-8578488A9B9F',
  },
  {
    name: 'ÅÅ_AFB',
    supplierId: 'CD62F1A6-60C3-4AEA-9C97-C0D062D67C07',
  },
  {
    name: 'ÅÅ_AFH',
    supplierId: '1C57D63A-FF87-4266-BC4E-A23B544AA643',
  },
  {
    name: 'ÅÅ_AFKoncern',
    supplierId: '59D4E27F-94B5-4234-883E-082676A2A450',
  },
  {
    name: 'ÅÅ_AFP',
    supplierId: '01051905-64DD-4CA8-ACD1-49C5DEB4D728',
  },
  {
    name: 'ÅÅ_AFS',
    supplierId: '9E570B88-3BF4-4D5F-B16C-883A6EEE7A58',
  },
  {
    name: 'Åbrinkens Grundejerforening',
    supplierId: 'E438A329-747E-4571-85C6-A746F8A8D2F3',
  },
  {
    name: 'Ærøskøbing Fjernvarme A.m.b.a.',
    supplierId: '140D567C-1BD5-4FA8-BA04-AA8ECD3B99B6',
  },
  {
    name: 'Aabenraa Fjernvarme',
    supplierId: '36793E9C-71E7-4DD5-B386-654FEEEEDB21',
  },
  {
    name: 'Aabybro Fjernvarmeværk',
    supplierId: '20F0832D-F02E-4749-AE23-E39E5802C110',
  },
  {
    name: 'Aabybro Vand',
    supplierId: '52F7AFB3-C687-4A39-A27D-342AD5C3C2BB',
  },
  {
    name: 'Aale Fjernvarme',
    supplierId: '92FA18D6-46C2-4457-A1E9-B5A59EF838EC',
  },
  {
    name: 'Aalestrup Vand',
    supplierId: '5AE1507E-D219-49F4-95FB-C87338FC67A0',
  },
  {
    name: 'Aars Fjernvarme',
    supplierId: '033B86A7-1CA8-476D-818C-116CD8430B40',
  },
  {
    name: 'Aars Vand',
    supplierId: '4566A35E-6894-4770-8D83-16678716BC9A',
  },
  {
    name: 'Aastruplund Vandværk',
    supplierId: '783347F2-250C-4CF1-8890-C8A2B4EC614D',
  },
  {
    name: 'Addit Vandværk',
    supplierId: 'AF3181AC-840E-4E50-A816-109BF967FB3D',
  },
  {
    name: 'Agersted Vandværk',
    supplierId: '417E6609-F29E-461B-9CA5-19E655866135',
  },
  {
    name: 'Agersted Varmeværk',
    supplierId: 'EAED1343-E312-4604-A6AC-2AEA6E437207',
  },
  {
    name: 'AK Fjernvarme',
    supplierId: '7A78940F-E32A-4464-90B8-1C2BD99D3A94',
  },
  {
    name: 'Albertslund Forsyning',
    supplierId: '60E7FBB1-E11E-4DFA-973F-F4F888BDE574',
  },
  {
    name: 'Allingåbro Varmeværk a.m.b.a',
    supplierId: '895EFE23-2EFF-4B84-A6E1-E21FB1A06804',
  },
  {
    name: 'Almtoft Kjellerup Vandværk',
    supplierId: '07026EBC-5635-4A70-B381-34BB896ACEDD',
  },
  {
    name: 'AN Energi',
    supplierId: '5AE1507E-D219-49F4-95FB-C87338FC67A0',
  },
  {
    name: 'Andelsselskabet Gram Vandværk',
    supplierId: '9F331A88-88ED-46A2-8446-E8C53C8594E7',
  },
  {
    name: 'Annasminde Varmeforsyning A.m.b.a.',
    supplierId: '57C0A7D3-E1AA-42CF-9D83-308E566F517D',
  },
  {
    name: 'Ans Kraftvarmeværk',
    supplierId: '8449FD1D-7122-4922-A78C-2D6FB9E39226',
  },
  {
    name: 'Ansager Varmeværk',
    supplierId: 'BCDA74EB-F931-4CC5-A047-41F4F179F2F7',
  },
  {
    name: 'Arden Varmeværk',
    supplierId: 'D80AE640-13E6-43DF-9D42-42CE4805DDC7',
  },
  {
    name: 'Asaa Fjernvarme',
    supplierId: 'CDEA027B-2EBA-48F5-A2D4-9BAEF0C97112',
  },
  {
    name: 'Assens Fjernvarme (Fyn)',
    supplierId: '73FD4EF9-7684-4BBC-9E0E-877D73D6DA7D',
  },
  {
    name: 'Attrup Vand',
    supplierId: '923AEAFC-38AC-46DE-B828-F3736AC80E67',
  },
  {
    name: 'Aulum Fjernvarme a.m.b.a. og Aulum Vandværk a.m.b.a.',
    supplierId: 'E84A1F2B-5601-471F-A7B1-723AA941608B',
  },
  {
    name: 'Aulum Vand Finans',
    supplierId: 'D4C920C2-D9A1-4F0F-8E50-C5C45ACCE258',
  },
  {
    name: 'Avedøre Fjernvarme amba',
    supplierId: 'A16B623F-9AE8-4152-949B-03B19A96F644',
  },
  {
    name: 'Bækmarksbro Varmeværk',
    supplierId: 'F376F4A6-D3EA-456F-A100-AE6C6548E05C',
  },
  {
    name: 'Bælum Varmeværk',
    supplierId: '234E1B07-4BF8-471F-BAFD-56DD9E2C4D16',
  },
  {
    name: 'Balling-Rødding Varmeværk A.m.b.a.',
    supplierId: 'DA8374A6-4176-421B-BAB4-C88FA57F1F2E',
  },
  {
    name: 'Bedsted Fjernvarme A.m.b.A.',
    supplierId: 'B18720CC-3939-455C-BD5B-B70C0F33FDC0',
  },
  {
    name: 'Billum Vandværk',
    supplierId: 'AD71217C-0845-45C5-A79B-0EB4B31989FA',
  },
  {
    name: 'Billund Varmeværk a.m.b.a.',
    supplierId: '0943A6CF-D4F5-47C2-9A1F-32B6BAA3CAD7',
  },
  {
    name: 'Bindslev Fjernvarme',
    supplierId: '8634BF04-90DB-48E9-8722-B8FC0C3D5210',
  },
  {
    name: 'Bjæverskov Fjernvarme A.M.B.A.',
    supplierId: '9AA89D1A-2348-4FF6-BFBD-BDA7C690BB27',
  },
  {
    name: 'Blære By Vand',
    supplierId: '798530E8-4770-4FA8-B219-FB6F637D642D',
  },
  {
    name: 'Blåhøj Energiselskab',
    supplierId: '2E6AE7D5-3B67-414F-9904-6338507C0046',
  },
  {
    name: 'Blenstrup Kraftvarme',
    supplierId: '717A41CB-32CE-4500-BA16-459BE9432719',
  },
  {
    name: 'Bogense Forsyningsselskab a.m.b.a. / Bogense Forsyning (vand)',
    supplierId: '72E1EFE4-26C4-4020-B4DB-EC85D0D3235B',
  },
  {
    name: 'Borup Vand A.M.B.A.',
    supplierId: '982E8F07-4C60-45E2-BF75-114676E238F3',
  },
  {
    name: 'Borup Varmeværk',
    supplierId: '67C4F580-5869-47C2-81C9-A19F944AFBA0',
  },
  {
    name: 'Boulstrup-Hou Kraftvarmeværk',
    supplierId: 'D7DD27DA-5A32-4B48-8DD5-4AF68CC129EB',
  },
  {
    name: 'Brædstrup Fjernvarme',
    supplierId: 'D13F9E5A-FE21-4382-9829-6B7E2FE5EDDF',
  },
  {
    name: 'Brædstrup Vandværk',
    supplierId: 'D87434B0-9CF9-423F-A5E1-831DF7F4413D',
  },
  {
    name: 'Brørup Fjernvarme',
    supplierId: '3DC190AD-559C-4BFF-9C1F-D5EF0BF820DB',
  },
  {
    name: 'Brørup Vandværk',
    supplierId: '99523FEB-FD69-45D6-BE98-C5C74E6AF538',
  },
  {
    name: 'Bramming Fjernvarme a.m.b.a.',
    supplierId: '742EE886-1D9B-4446-B0B4-580783EF68C6',
  },
  {
    name: 'Brande Fjernvarme A.m.b.a.',
    supplierId: '90A3A92D-EEFE-4699-B181-8784C5FB5BD0',
  },
  {
    name: 'Bratskov Vand',
    supplierId: 'C97B482D-CE75-4C36-B7DB-F452C979F6A7',
  },
  {
    name: 'Bredebro Varmeværk',
    supplierId: '33057A1E-E67B-46F2-A8B7-1EF62D7412CB',
  },
  {
    name: 'Bredsten-Balle Kraftvarmeværk A.m.b.a',
    supplierId: '68A65157-B149-415E-B8A2-1DED86732E9A',
  },
  {
    name: 'Broager Vandværk',
    supplierId: '5978F728-52E3-49C3-BBD8-2883024EFFB8',
  },
  {
    name: 'Brovst Fjernvarme a.m.b.a.',
    supplierId: '0138E395-8F9E-43AD-B5F9-C2BB65836837',
  },
  {
    name: 'Christiansfeld Fjernvarmeselskab A.m.b.a.',
    supplierId: '8E470976-B440-41FA-99C0-FA5D0328775B',
  },
  {
    name: 'Døstrup Vandværk',
    supplierId: 'B07DEE58-AD2D-4B37-82F0-192D31450BA3',
  },
  {
    name: 'Demo Vand',
    supplierId: '9C9B4999-DB67-43F8-A9CD-530C5DB4E100',
  },
  {
    name: 'DFF|EDB a.m.b.a.',
    supplierId: 'F166103F-6C24-47B3-B097-557A7CFE62BA',
  },
  {
    name: 'Dianalund Fjernvarme',
    supplierId: '9ADC414A-BE32-424C-83D7-46103894E1DC',
  },
  {
    name: 'Dragør Fjernvarme',
    supplierId: '6753FE78-EF19-4531-8C50-62175A7EAC9E',
  },
  {
    name: 'Dronninglund Fjernvarme A.m.b.A',
    supplierId: '66D241DC-AE10-49F5-A176-81CC8C58BEF7',
  },
  {
    name: 'Durup Fjernvarme',
    supplierId: '337DBB0D-BB0E-4C31-A6C3-5F67EB20E44A',
  },
  {
    name: 'E.ON Varme (Frederikssund, Lendemarke, Ålsgårde, Hjortekær, Ørslev Terslev)',
    supplierId: 'A3A69B19-6944-45BB-967B-14FAAE6891D8',
  },
  {
    name: 'Ebeltoft Fjernvarmeværk',
    supplierId: '00AA52BB-CAD6-4658-BEBB-3B9E6D2DD5CD',
  },
  {
    name: 'EBO Consult',
    supplierId: '40A67E87-35A1-41B8-8678-229C547B4DA6',
  },
  {
    name: 'EForsyning - Ny Angular',
    supplierId: '9C9B4999-DB67-43F8-A9CD-530C5DB4EB97',
  },
  {
    name: 'EForsyning Brøndby',
    supplierId: '6BE0A902-3990-47D5-BDFD-4EBBC7838836',
  },
  {
    name: 'EForsyning Brøndbylund',
    supplierId: '6BE0A902-3990-47D5-BDFD-4EBBC7838836',
  },
  {
    name: 'EForsyning Priorparken',
    supplierId: '6BE0A902-3990-47D5-BDFD-4EBBC7838836',
  },
  {
    name: 'EForsyning Ragnesminde',
    supplierId: '6BE0A902-3990-47D5-BDFD-4EBBC7838836',
  },
  {
    name: 'EForsyning Stationsparken, Glostrup',
    supplierId: '6BE0A902-3990-47D5-BDFD-4EBBC7838836',
  },
  {
    name: 'Egebjerg Nærvarme',
    supplierId: '41CA7026-D65E-457D-8E4C-F2729BE8DE4D',
  },
  {
    name: 'Egedal Fjernvarme A/S',
    supplierId: '8E4CF8E1-14BC-4F27-B006-7DAFD898AABB',
  },
  {
    name: 'Egtved Varmeværk',
    supplierId: 'A68CA72E-8888-4BD1-84E6-89A123510855',
  },
  {
    name: 'Ejby Vandværk a.m.b.a.',
    supplierId: '1BBFD2CE-D9C9-46EE-A0C1-231DE980E7C7',
  },
  {
    name: 'Ejsing Fjernvarme',
    supplierId: 'B915CE92-24DB-43FA-B14F-A18E9CC5ACB0',
  },
  {
    name: 'Ejstrupholm Vandværk',
    supplierId: 'A0FF3AD3-CAAA-4D65-B414-AC9BB163A444',
  },
  {
    name: 'Ejstrupholm Varmeværk',
    supplierId: 'A0FF3AD3-CAAA-4D65-B414-AC9BB163A444',
  },
  {
    name: 'Ellidshøj-Ferslev Kraftvarmeværk',
    supplierId: '06095C91-C5CF-4A64-A371-ED3B2311500A',
  },
  {
    name: 'Fandrup Vand',
    supplierId: '5ADD2064-DB8A-4776-ADC2-1343C4625E2C',
  },
  {
    name: 'Farsø Vand',
    supplierId: 'B12534E0-3917-42FE-91A5-87F6ACF905EB',
  },
  {
    name: 'Farsø Varmeværk a.m.b.a.',
    supplierId: '323997A4-2714-41A5-869C-ABB0330BB9EE',
  },
  {
    name: 'Faxe Energi A/S',
    supplierId: '415613BD-C6D6-420F-A674-2238B6EB469F',
  },
  {
    name: 'Faxe Fjernvarme',
    supplierId: '524B404F-045A-400B-9F03-3BE2675BF668',
  },
  {
    name: 'FDHvidovre Fjernvarme',
    supplierId: '8EF73196-0845-4860-8A1F-25BC34DD5BF2',
  },
  {
    name: 'Feldborg Kraftvarmeværk A.m.b.a',
    supplierId: '6D313FC2-B118-4188-848D-03B201D324D3',
  },
  {
    name: 'Fensmark Fjernvarme a.m.b.a.',
    supplierId: '7E549D97-27BD-4F81-89B6-A8C1C6B2C80F',
  },
  {
    name: 'Fensmark Vandværk',
    supplierId: 'EE56D1BF-3440-4E59-89F6-EA59D8BA8D03',
  },
  {
    name: 'Filskov Energiselskab',
    supplierId: '231775F2-3D05-4B37-BEAE-BDD52D9E35BB',
  },
  {
    name: 'FJARHITAFELAGIÃ P/F',
    supplierId: '5C6D132A-2F1C-4D0A-9BED-A89ECBD2299A',
  },
  {
    name: 'Fjernvarme Horsens',
    supplierId: '8B563AC8-706E-45C6-A23C-A6CABCAE3E41',
  },
  {
    name: 'Fjernvarmecentralen Avedøre-Holme',
    supplierId: 'D0217821-615E-4EDE-89D2-C661CD32795F',
  },
  {
    name: 'Fjerritslev Fjernvarme a.m.b.a.',
    supplierId: 'CE889842-E345-49B8-8B3A-172CE70E5175',
  },
  {
    name: 'Fjerritslev Vandværk',
    supplierId: '344FA19F-28B6-4D9F-9689-22FD8B54FC4C',
  },
  {
    name: 'Flejsborg Vand',
    supplierId: '9516F36B-2EB9-4926-8EC6-5A482BA86E48',
  },
  {
    name: 'Fredensborg Fjernvarme',
    supplierId: '44D82A4B-7C43-4838-A046-CDA86D8ED1CB',
  },
  {
    name: 'Fredericia Fjernvarme a.m.b.a.',
    supplierId: '11E1D178-7D80-46F6-AFDF-8D2B4646ED20',
  },
  {
    name: 'Frederiks Varmeværk',
    supplierId: '71AD144C-3C64-47FC-82B4-E1360D7AAE38',
  },
  {
    name: 'Frejlev Vand',
    supplierId: '736646ED-D820-47A8-9419-F66B3BA30699',
  },
  {
    name: 'Fuglebjerg Fjernvarme',
    supplierId: '95E3B78E-7FA9-4747-8D6B-BB2B61468D2F',
  },
  {
    name: 'Fuglebjerg Vandværk a.m.b.a.',
    supplierId: 'CEACCAA2-A33C-4A7B-8E69-004EAB6F6CDF',
  },
  {
    name: 'Fur Kraftvarme',
    supplierId: 'DA0332FD-50CF-450A-94B2-4F045E91443B',
  },
  {
    name: 'Gørding Varmeværk',
    supplierId: '4F93AEEE-1588-410C-A098-0E6371AC37EC',
  },
  {
    name: 'Gårde Vandværk',
    supplierId: '5009F83A-CC88-4D05-A429-2224FEF7D5DC',
  },
  {
    name: 'Gammel Blære vand',
    supplierId: '75D2FE2E-3974-4D91-A47F-C2EEBEC6DDFC',
  },
  {
    name: 'Gauerslund Fjernvarme A.m.b.a.',
    supplierId: '8F951A21-046E-4900-891F-16E88F59565C',
  },
  {
    name: 'Gelsted Fjernvarme A.m.b.a.',
    supplierId: '2BB7607A-6E88-4AC7-927D-846667535AC3',
  },
  {
    name: 'Genner, Hellevad og Hovslund Forenede Kraftvarmeværker',
    supplierId: 'BFBF459F-C861-4535-91F2-32C0F3875928',
  },
  {
    name: 'Gentofte Fjernvarme',
    supplierId: 'BDBF8661-B8A4-47FD-97BC-239893E46DCF',
  },
  {
    name: 'Gilleleje Fjernvarme a.m.b.a.',
    supplierId: '65F603A9-C84F-4A46-BDB2-36FC10E44D92',
  },
  {
    name: 'Give Fjernvarme',
    supplierId: '001BC1AC-200B-4811-B449-A5F9D47F7030',
  },
  {
    name: 'Gjern Vandværk',
    supplierId: '05776088-CCDB-460E-9E45-72483EA7D546',
  },
  {
    name: 'Gjern Vandværk',
    supplierId: '05776088-CCDB-460E-9E45-72483EA7D546',
  },
  {
    name: 'Gjerndrup Vandværk',
    supplierId: 'A740D943-640D-4492-ABFE-0ECAFA82EAC4',
  },
  {
    name: 'Gl. Rye Vandværk',
    supplierId: '3D453F07-49AA-4A2B-A3B8-0027AD7A8CE2',
  },
  {
    name: 'Gladsaxe Fjernvarme',
    supplierId: '8CBCABDB-C971-4548-8D26-F35881640DE8',
  },
  {
    name: 'Glamsbjerg-Haarby Varmeværk',
    supplierId: '80815463-86B3-472A-885A-79AE5CB32F9A',
  },
  {
    name: 'Glud',
    supplierId: '57C0A7D3-E1AA-42CF-9D83-308E566F517D',
  },
  {
    name: 'Glyngøre Fjernvarme',
    supplierId: '337DBB0D-BB0E-4C31-A6C3-5F67EB20E44A',
  },
  {
    name: 'Græsted Fjernvarme',
    supplierId: '34E52079-6D55-4CD2-BFED-34F2BFC9EF80',
  },
  {
    name: 'Gråsten Varme',
    supplierId: 'F92E5BB9-3642-41A4-B764-8F14EEDD3156',
  },
  {
    name: 'Gram Fjernvarme',
    supplierId: '6A6BF495-3889-465A-AD9D-9980A202E96A',
  },
  {
    name: 'Grenaa Varmeværk',
    supplierId: 'BE112409-C45D-4E63-BFF6-1C4E8F9ED990',
  },
  {
    name: 'Greve Fjernvarme',
    supplierId: 'B82285E4-1E8B-4F66-BA8C-4444E2329C22',
  },
  {
    name: 'Grundejerforeningen Rønneholtparken',
    supplierId: 'B3E3BEB7-BE48-4328-A2D2-8083DFF5F751',
  },
  {
    name: 'Gudenådalens Energiforsyning',
    supplierId: '6F2A51C3-0098-4A05-A677-131D516E765E',
  },
  {
    name: 'Gundersted Vandværk',
    supplierId: '3024706B-CC04-40DD-9291-3A67603F4313',
  },
  {
    name: 'Gundestrup-Giver Vand',
    supplierId: '033AC608-ECCE-4A3A-9AF4-AA9930ADC612',
  },
  {
    name: 'Høje Taastrup Fjernvarme',
    supplierId: '4DA78D70-B57F-4AD8-A037-2E62FBA3E0CD',
  },
  {
    name: 'Højslev Nr. Søby',
    supplierId: '9099C5C5-7CDC-4C40-AF4C-2CEF84584DFE',
  },
  {
    name: 'Høng Varmeværk A.M.B.A.',
    supplierId: 'AEF498BC-1548-4521-8114-B20F516DA517',
  },
  {
    name: 'Haderslev Fjernvarme',
    supplierId: 'C3FF9A98-84EC-42F7-A7B0-44B1B24F8ACF',
  },
  {
    name: 'Haderup Kraftvarmeværk a.m.b.a.',
    supplierId: '3267646D-F2AF-44E7-B6B5-1CD9B38806E1',
  },
  {
    name: 'Hadsten Varme',
    supplierId: 'E75C66C7-CAEB-40E3-A0C3-AA7D5FF9940F',
  },
  {
    name: 'Hadsund Fjernvarme a.m.b.a.',
    supplierId: '49C73776-76BE-4382-BA5C-2B4E7384CC34',
  },
  {
    name: 'Hals Fjernvarme AmbA',
    supplierId: '6761B184-DF59-4105-90A5-09DBB7955668',
  },
  {
    name: 'Halsnæs Vandforsyning A.m.b.a.',
    supplierId: '82135D7E-DD2C-4D77-8A80-24D77299FBFF',
  },
  {
    name: 'Halsnæs Varme A/S',
    supplierId: '9B12567F-F0CB-4FF1-A106-5C8DBF482E4D',
  },
  {
    name: 'Halvrimmen-Arentsminde Kraftvarmeværk A.m.b.a',
    supplierId: '781B5576-D791-487F-ADDD-AE240A5673F3',
  },
  {
    name: 'Hammel Fjernvarme a.m.b.a.',
    supplierId: 'F97D7E2D-EB87-4122-A01F-44244527317A',
  },
  {
    name: 'Hammershøj Fjernvarmeværk',
    supplierId: '572F87E9-F46D-4DF8-B947-566B35C1AD87',
  },
  {
    name: 'Hanstholm Varmeværk',
    supplierId: '40BAA55A-E71F-41B7-800D-4BEED3AA41AE',
  },
  {
    name: 'Hashøj Kraftvarmeforsyning',
    supplierId: 'F12F8ED0-CF15-4FFA-AE61-4C02F1158842',
  },
  {
    name: 'Haslev Fjernvarme A.m.b.a.',
    supplierId: '7FDC9D76-21E2-40C8-BD62-F932DB4812E6',
  },
  {
    name: 'Havneby Varmeværk',
    supplierId: 'B07DEE58-AD2D-4B37-82F0-192D31450BA3',
  },
  {
    name: 'Hedegårdens Varmecentral',
    supplierId: '22B20D48-F1DF-4072-8149-8AAA33B24AC8',
  },
  {
    name: 'Hedensted Fjernvarme',
    supplierId: '4F2200AF-8833-4237-81D9-E5CEF34582A2',
  },
  {
    name: 'Hellevad Vandværk',
    supplierId: 'F221EB23-EE81-49AE-95FE-54DFA7783DE8',
  },
  {
    name: 'Helsinge Fjernvarme a.m.b.a.',
    supplierId: '478043AB-B215-4E8D-B300-F2934C6E64CC',
  },
  {
    name: 'Helsinge Vandværk',
    supplierId: '3CB0F10B-DB25-4070-A429-023DB8C4A675',
  },
  {
    name: 'Hemmet Varmeværk',
    supplierId: 'F007B237-DE3C-4BCC-9F23-5D7A8F7F3C34',
  },
  {
    name: 'Herborg Vandværk',
    supplierId: '5B726FCC-A034-4C73-B6B2-B4E5B5DD7BF3',
  },
  {
    name: 'HFS v/EBO Consult',
    supplierId: '3D1DAE3D-35B6-445B-AE23-82D8F1A93717',
  },
  {
    name: 'Hinnerup Fjernvarme',
    supplierId: '10340F7C-C2B6-4009-BFFD-135C92EDC28A',
  },
  {
    name: 'Hirtshals Fjernvarme a.m.b.a.',
    supplierId: 'E3EAF0F3-0583-487D-B2F8-B4D1D242FCAA',
  },
  {
    name: 'Hjørring Varmeforsyning',
    supplierId: 'B30A6948-2461-4827-B8EB-5D93169CCB8B',
  },
  {
    name: 'Hjallerup Fjernvarme A.m.b.a',
    supplierId: 'C27ACFDB-E48D-474B-B46A-1E2CA0C96D64',
  },
  {
    name: 'Hjordkær Fjernvarmeværk',
    supplierId: 'BB5CD119-FE31-446F-A914-F429928A6C7A',
  },
  {
    name: 'Hobro Varmeværk A.m.b.a.',
    supplierId: '2A5E4ADD-D579-4B7C-85E2-116B459D70C0',
  },
  {
    name: 'Holeby Fjernvarme',
    supplierId: '41B9709E-5375-4A93-A372-71EF7F36FDC9',
  },
  {
    name: 'Holme Lundshøj Fjernvarme',
    supplierId: 'A9427320-591C-4FA4-9D05-30D223C17CB5',
  },
  {
    name: 'Holsted Varmeværk',
    supplierId: '6AAD8189-6F3B-44E3-8104-53A77D2D0164',
  },
  {
    name: 'Hornbæk Fjernvarme A.m.b.a.',
    supplierId: '3D05D7F7-6F0B-4A4F-9428-B148B408178E',
  },
  {
    name: 'Hornslet Fjernvarme A.m.b.a.',
    supplierId: 'CB473D79-8603-415A-9B45-2342F9765E36',
  },
  {
    name: 'Hovedgård Fjernvarme a.m.b.a.',
    supplierId: '6760D4AE-652B-4FCF-83B2-F7F5563B53CF',
  },
  {
    name: 'Hurup Elværk A.m.b.A.',
    supplierId: '07E4FE2C-5547-43EF-951A-D4F31570FFC4',
  },
  {
    name: 'Hurup Elværk Net A/S',
    supplierId: '3AF44416-8D19-49D7-9E66-2513FE9A6DD0',
  },
  {
    name: 'Hurup Fjernvarme A.m.b.A.',
    supplierId: 'C5804B3E-F0AF-41EB-84E4-DCE6DAFD6F54',
  },
  {
    name: 'Hurup Vandværk',
    supplierId: '7F1196E7-BDA8-4603-BB25-272241C07DD5',
  },
  {
    name: 'Husby Sdr. Aaby Vandværk',
    supplierId: '8BF5B887-61A3-45F5-A8C6-174C75E96BC4',
  },
  {
    name: 'Hvalsø Kraftvarmeværk',
    supplierId: 'F884BB11-F760-4876-B75D-F3B2569FAB9E',
  },
  {
    name: 'Hvide Sande Fjernvarme A.m.b.A.',
    supplierId: 'EBEABBB7-DF01-4370-84E8-AEF8538BF1CE',
  },
  {
    name: 'Hvidebæk Fjernvarmeforsyning',
    supplierId: 'D15E6552-E7FC-4C0D-85A4-C25D3D581BCE',
  },
  {
    name: 'Hyllebjerg Vandværk',
    supplierId: 'CD4C4EB2-2820-43C9-B5E3-1834EF5988D1',
  },
  {
    name: 'Ishøj Varmeværk',
    supplierId: '72FCA0B9-0F15-44D0-89C6-806E65ADCEF1',
  },
  {
    name: 'Jægerspris Kraftvarme',
    supplierId: '1C1A90B5-3CDA-4EA6-BBCA-94CF1CCFFB84',
  },
  {
    name: 'Jegum-Vrøgum Vandværk',
    supplierId: '3320FF2C-44CA-45A5-87FC-C18C97DC9E5C',
  },
  {
    name: 'Jelling Varmeværk',
    supplierId: '88256BCF-FEBB-44B1-A141-2EF31A0E4070',
  },
  {
    name: 'Jerslev Kraftvarmeværk',
    supplierId: 'F2A9BA63-D737-4B9D-B2AD-508E644EAF6E',
  },
  {
    name: 'Jetsmark Energiværk',
    supplierId: '7456739D-8AB3-48CE-AD7F-E6B8DA89E14E',
  },
  {
    name: 'Køge Fjernvarme',
    supplierId: '95347942-AB09-485C-B5A4-8872AAA6F79A',
  },
  {
    name: 'Karrebæk Fjernvarme',
    supplierId: '6BCF0EEE-02A2-4AA4-A05A-1858276FC50B',
  },
  {
    name: 'Karup Vandværk',
    supplierId: '0302F869-F830-4497-9B68-FC95957421D5',
  },
  {
    name: 'Karup Varmeværk',
    supplierId: '0A7966CE-9320-4C7A-A494-7643413A9AAF',
  },
  {
    name: 'Kibæk Varmeværk',
    supplierId: 'BE52FAA0-ED91-444A-BE77-678316B1C07E',
  },
  {
    name: 'Kirke Hyllinge Vandværk',
    supplierId: '1AA09FC9-E39F-4621-A63F-2C525A51889F',
  },
  {
    name: 'Kjellerup Fjernvarme Amba',
    supplierId: '07026EBC-5635-4A70-B381-34BB896ACEDD',
  },
  {
    name: 'Kolind Fjernvarmeværk a.m.b.a.',
    supplierId: '122DC0FB-49A3-4A4B-B1E1-689CBAC080D5',
  },
  {
    name: 'Kongerslev Fjernvarme',
    supplierId: '4A530E73-227F-4ACB-9D9B-A84905470921',
  },
  {
    name: 'Krastrup-Kølby Vandværk',
    supplierId: '78925464-11E3-4FA1-8996-5F23D196EB3D',
  },
  {
    name: 'Kværndrup Fjernvarme a.m.b.a.',
    supplierId: '2263396C-0D85-443F-9DF4-587390873C28',
  },
  {
    name: 'Løgstrup Fjernvarme',
    supplierId: '90B02303-2CFF-4E97-ABE8-C57996942231',
  },
  {
    name: 'Løgten-Skødstrup Fjernvarmeværk',
    supplierId: '159C8291-DC56-4400-B1C5-55E766DB05D6',
  },
  {
    name: 'Løgumkloster Fjernvarme',
    supplierId: 'ACA66C8B-A084-465D-8DBF-D1D510E0B9E3',
  },
  {
    name: 'Løjt Kirkeby Fjernvarmeselskab',
    supplierId: '372B7CD9-FEF6-47EB-86E2-859FF97525FA',
  },
  {
    name: 'Løkken Varmeværk',
    supplierId: '54EA9177-8AAB-4D90-8E08-66694AD324E4',
  },
  {
    name: 'Løkkenvejens Kraftvarmeværk',
    supplierId: 'ADC6445D-A228-4A7A-A520-634ECA304AC1',
  },
  {
    name: 'Lørslev Varmeforsyning',
    supplierId: '1F4BF4FC-0C7F-4068-8AAA-9ADDFBE5243C',
  },
  {
    name: 'Løsning Fjernvarme a.m.b.a.',
    supplierId: '7EA4895A-8C70-47BC-AB7D-CF432EBC8A9B',
  },
  {
    name: 'Løsning Vandværk',
    supplierId: '68AB8F08-AB7D-421B-9D79-AF87A8D98DF6',
  },
  {
    name: 'Langå Varmeværk A.m.b.a.',
    supplierId: '80A8F794-6083-46B1-B0F2-607ED2A85AC3',
  },
  {
    name: 'Laurbjerg Kraftvarmeværk A.m.b.a.',
    supplierId: 'F28E5C6E-70F5-418F-BBCC-31296AB04DA9',
  },
  {
    name: 'Lem Varmeværk',
    supplierId: 'C2CFAF7A-8A1D-4468-8B10-3BDD42D7705C',
  },
  {
    name: 'Lemvig Varmeværk',
    supplierId: 'AC3C048A-78F6-4EEC-8B0E-34C8724F8EC9',
  },
  {
    name: 'Lendum Kraftvarmeværk',
    supplierId: 'B4D5BEDE-D18E-48D5-A03A-AF141947849D',
  },
  {
    name: 'Lohals Varmeforsyning',
    supplierId: '42EB3DB0-8C83-4163-9775-AAB8F2F55577',
  },
  {
    name: 'Lund Vandværk',
    supplierId: '795E3F8B-56C1-49E9-AAAB-91315FE3D787',
  },
  {
    name: 'Lystrup Fjernvarme A.m.b.A.',
    supplierId: '4C0F3E0C-1704-4A17-8309-BD4D0E951ED1',
  },
  {
    name: 'Møldrup Varmeværk',
    supplierId: '4CA9C324-5842-4A80-874B-B213AFD872B1',
  },
  {
    name: 'Mølholm Varmeværk',
    supplierId: 'B8DAB5F7-4D19-4E55-BE4B-E9C3A2715D40',
  },
  {
    name: 'Mørkøv Varmeværk',
    supplierId: '36f88282-7eb9-4d71-92ab-343bd7ef1883',
  },
  {
    name: 'Mørke Fjernvarme',
    supplierId: '27BE22FD-CFB5-4989-9F50-640798E4DCCD',
  },
  {
    name: 'Malling Varmeværk',
    supplierId: '1113B417-7571-447D-A9E8-6598F52A5DE8',
  },
  {
    name: 'Mariager Fjernvarmeværk',
    supplierId: '3B8CAA35-0DB2-41A8-ACB0-EAAB9338D7F9',
  },
  {
    name: 'Maribo Varmeværk',
    supplierId: 'BC3885CD-2374-4536-AA6A-557B4D9E9E9E',
  },
  {
    name: 'Marstal Fjernvarme A.m.b.a.',
    supplierId: '6BC25F8C-370A-40AB-9971-603C31AEDCA8',
  },
  {
    name: 'Mejlby Fjernvarme AMBA',
    supplierId: '4246CBF3-C9AA-4563-B110-F9FD1B6E8F98',
  },
  {
    name: 'Merkur Fjernvarme',
    supplierId: '9C9B4999-DB67-43F8-A9CD-530C5DB4EB97',
  },
  {
    name: 'Merkur GIS',
    supplierId: '9C9B4999-DB67-43F8-B9CD-530C5DB4EB97',
  },
  {
    name: 'Middelfart Fjernvarme',
    supplierId: 'EDB2E44E-9586-45DE-B6C3-80E4FE36C9F7',
  },
  {
    name: 'Midtfyn elforsyning',
    supplierId: 'F10CA728-8D51-442F-86A9-14B45CD54EF2',
  },
  {
    name: 'Midtfyns Energi',
    supplierId: '6DCA1A3F-7754-4D0D-AD26-649E0336025D',
  },
  {
    name: 'Midtlangeland Fjernvarme A.m.b.a.',
    supplierId: 'B4449BD8-FCDB-486B-BE65-003387C719BD',
  },
  {
    name: 'Mosede Fjernvarmeværk',
    supplierId: 'CA63442F-C524-4FA0-A8FC-BDBC688D0E2D',
  },
  {
    name: 'Mou Kraftvarme',
    supplierId: '3E70D162-0F15-4404-80BB-73AE3A20BB4A',
  },
  {
    name: 'Næstved Fjernvarme A.m.b.A.',
    supplierId: 'EB786180-789E-47E4-B19B-3281E87109F5',
  },
  {
    name: 'Nørre Aaby Vandværk',
    supplierId: '058A2CAC-28CE-4F7C-B273-C98269387414',
  },
  {
    name: 'Nørre Alslev Fjernvarmeværk a.m.b.a.',
    supplierId: '835C7CB6-6D99-4ED9-A422-55942F9413E1',
  },
  {
    name: 'Nørre Nebel Fjernvarme',
    supplierId: 'F007B237-DE3C-4BCC-9F23-5D7A8F7F3C34',
  },
  {
    name: 'Nørre Snede Vandværk',
    supplierId: '87113BFB-34CD-4F8B-B823-A1DA34A90174',
  },
  {
    name: 'Nørre Snede Varmeværk',
    supplierId: '87113BFB-34CD-4F8B-B823-A1DA34A90174',
  },
  {
    name: 'Nørrevejens Kraftvarmeværk',
    supplierId: 'B07DEE58-AD2D-4B37-82F0-192D31450BA3',
  },
  {
    name: 'Nørskovlund vand',
    supplierId: 'D3A81E32-CBDB-472E-B11E-D73E1DC92479',
  },
  {
    name: 'Nibe Varmeværk a.m.b.a.',
    supplierId: '88E9F488-3493-4A6A-AD5C-D74FE021F678',
  },
  {
    name: 'Nim Vandværk',
    supplierId: 'DDF4115D-8D5F-4EE8-84D0-F8616E738A18',
  },
  {
    name: 'Nimtofte og Omegns Fjernvarmeforsyning',
    supplierId: 'F92E5BB9-3642-41A4-B764-8F14EEDD3156',
  },
  {
    name: 'Nordby Fjernvarme a.m.b.a.',
    supplierId: '04A0608B-6914-4333-B48F-3157C27F63A4',
  },
  {
    name: 'Norfors Fjernvarme',
    supplierId: '44D82A4B-7C43-4838-A046-CDA86D8ED1CB',
  },
  {
    name: 'Nyhuse Vandværk A.m.b.a.',
    supplierId: '08268716-941B-4172-A8A9-492784B6C3E0',
  },
  {
    name: 'Nykøbing Mors Fjernvarmeværk A.m.b.a.',
    supplierId: '32E08BCE-1F23-4A94-8B04-42F2DA03A3DD',
  },
  {
    name: 'Nykøbing Sj Varmeværk a.m.b.a.',
    supplierId: '17086977-7E29-4199-917D-1A76641671BC',
  },
  {
    name: 'Nysted Varmeværk a.m.b.a.',
    supplierId: '3DD20D3A-4749-42AA-9DD8-CE83FAC89465',
  },
  {
    name: 'Odder Forsyningsselskab',
    supplierId: '12285FDA-67CD-4D35-BB92-D222325B6CBA',
  },
  {
    name: 'Odder Vandværk',
    supplierId: 'ACD7B9D3-E7FA-41DF-A4C1-3E459AD74660',
  },
  {
    name: 'Odder Varmeværk',
    supplierId: 'ACD7B9D3-E7FA-41DF-A4C1-3E459AD74660',
  },
  {
    name: 'Oksbøl Vandværk',
    supplierId: '99CEB1D6-1C43-4008-9A03-74C8134DE24E',
  },
  {
    name: 'Oksbøl Varmeværk',
    supplierId: 'AD71217C-0845-45C5-A79B-0EB4B31989FA',
  },
  {
    name: 'Outrup Varmeværk',
    supplierId: '7D27FCC9-3E79-4B6F-80A6-D7C2D1C9F350',
  },
  {
    name: 'Overlund Fjernvarme',
    supplierId: 'C6CFCAA8-A5CD-4E13-B4CA-A9FFA0297E3F',
  },
  {
    name: 'Padborg Fjernvarme',
    supplierId: '1270CB1E-DA9E-4D13-8C67-B0540BEF3237',
  },
  {
    name: 'Præstø Fjernvarme a.m.b.a.',
    supplierId: 'C874E090-2769-4C2B-A2A8-418ECCEE57CB',
  },
  {
    name: 'Ræhr Fjernvarme',
    supplierId: 'A7F3DB12-D3A5-4981-A31A-1CE657B4D22A',
  },
  {
    name: 'Rødby Varmeværk a.m.b.a',
    supplierId: 'A27E65CE-11AC-4AE8-A4F7-F30DBA60EE60',
  },
  {
    name: 'Rødbyhavn Fjernvarme A.M.B.A.',
    supplierId: 'B07F2690-EBF5-4461-8F64-81C83D942FF3',
  },
  {
    name: 'Rødding Fjernvarme',
    supplierId: '2CEE9305-4D8E-404F-85E5-2F294CD573C5',
  },
  {
    name: 'Rødding Vandværk',
    supplierId: 'BE83B759-9751-4A95-8CD5-A5954A2B6DD8',
  },
  {
    name: 'Rødkærsbro Fjernvarmeværk A.m.b.A',
    supplierId: 'A661AA8A-D027-4280-AFC4-C02BC2AE0A8E',
  },
  {
    name: 'Rødovre Kommunale Fjernvarmeforsyning',
    supplierId: '6B37F777-00FD-4862-97FF-00BB90434C46',
  },
  {
    name: 'Rønde Fjernvarme',
    supplierId: 'DF89E061-7941-4D1C-9C38-7D951F091581',
  },
  {
    name: 'Ramsing-Lem-Lihme Kraftvarmeværk',
    supplierId: 'CECED2E6-EC7F-47DB-B3FE-806E8EDAC95F',
  },
  {
    name: 'Rask Mølle - Uldum Vand',
    supplierId: '2B822B69-65A1-4AED-8442-B13D455E6B82',
  },
  {
    name: 'Rask Mølle Uldum Forsyning',
    supplierId: '2B822B69-65A1-4AED-8442-B13D455E6B82',
  },
  {
    name: 'Ravnkilde Kraftvarmeværk',
    supplierId: '7C5B5243-E122-4A74-9C0D-846EB6E0D028',
  },
  {
    name: 'Ravnkilde Vand',
    supplierId: '510F8C9F-0D34-4B7C-859D-AD2FE63512BE',
  },
  {
    name: 'Rebæk Søpark A.m.b.a.',
    supplierId: '1D5D3326-38DD-492A-89F3-ECE8C2F97882',
  },
  {
    name: 'REFA Gedser Fjernvarme',
    supplierId: '347DFEC1-C280-4BCA-B059-D5AA1640F96B',
  },
  {
    name: 'REFA Horbelev Fjernvarme',
    supplierId: '53872A81-CC89-485B-8EC2-555316AFA69A',
  },
  {
    name: 'REFA Stubbekøbing Fjernvarme',
    supplierId: '8E2B005F-D427-4515-804C-E93D0D27E14A',
  },
  {
    name: 'Ribe Fjernvarme a.m.b.a.',
    supplierId: 'EDFDF7E8-3F3D-43F0-91A9-AA9103BEF40D',
  },
  {
    name: 'Ringkøbing Fjernvarmeværk',
    supplierId: '0EF3EA2A-DA10-416F-AF1C-B36FD44393C9',
  },
  {
    name: 'Rise Fjernvarme',
    supplierId: '145B07A1-84BC-492F-AE8E-7C20BF10018C',
  },
  {
    name: 'Roslev Fjernvarme a.m.b.a.',
    supplierId: '26318962-CA0E-45AA-AB91-FA84029F31EB',
  },
  {
    name: 'Rundhøj Fjernvarme',
    supplierId: 'A9427320-591C-4FA4-9D05-30D223C17CB5',
  },
  {
    name: 'Ry Varmeværk ApS',
    supplierId: '696B1597-BA8E-4D38-81EE-62AA7CBAF7FE',
  },
  {
    name: 'Rye Kraftvarmeværk',
    supplierId: 'F2420DA8-8438-4D9A-8329-0A955A1C1FA9',
  },
  {
    name: 'Ryomgård Fjernvarmeværk',
    supplierId: 'AA6EBAE0-69C3-4A8B-A52F-34240CC20B8A',
  },
  {
    name: 'Sæby Varmeværk a.m.b.a.',
    supplierId: '914E2A15-EEBB-4203-807A-45DFFDD963BF',
  },
  {
    name: 'Sønder Vissing Vandværk',
    supplierId: '8C787CCF-8C1F-46A2-A811-151582176AF4',
  },
  {
    name: 'Sønderborg Varme',
    supplierId: '0DA4BF5F-2857-44FA-9CA3-F90A3C04B01F',
  },
  {
    name: 'Sønderholm Varmeværk',
    supplierId: '5C066666-F5C2-446E-B9BC-99E5ED114624',
  },
  {
    name: 'Sakskøbing Fjernvarmeselskab',
    supplierId: 'C36AC32C-1E17-4E8D-882D-BFF38050978E',
  },
  {
    name: 'Saltum Fjernvarme AMBA',
    supplierId: 'AB165F16-5100-4A7B-9AC7-EDF5AA242C3F',
  },
  {
    name: 'Sandved-Tornemark Kraftvarmeværk',
    supplierId: '979589FF-032A-4D9B-9A10-5D0670FAC4B9',
  },
  {
    name: 'Sdr. Felding Varmeværk',
    supplierId: 'E70920D5-C25E-4A75-9D37-905A87D5BBAF',
  },
  {
    name: 'Sdr. Herreds Kraftvarmeværker',
    supplierId: 'C01BAA5B-09B6-4B57-8567-3C30D995D079',
  },
  {
    name: 'Sdr. Omme Varmeværk Amba',
    supplierId: '0B7A0AED-3EF4-487A-9E62-64AA3E187F93',
  },
  {
    name: 'Sindal Varmeforsyning A.m.b.a.',
    supplierId: '55C2F114-D191-464B-9164-0EA0D7A62CB5',
  },
  {
    name: 'Skærbæk Fjernvarme',
    supplierId: 'B07DEE58-AD2D-4B37-82F0-192D31450BA3',
  },
  {
    name: 'Skærbæk Vandværk',
    supplierId: 'B07DEE58-AD2D-4B37-82F0-192D31450BA3',
  },
  {
    name: 'Skørping Varmeværk a.m.b.a.',
    supplierId: 'D6A03A64-647E-4544-9C1E-1EAE601CDF33',
  },
  {
    name: 'Skårup Fjernvarme',
    supplierId: '96009363-4B95-4D6A-BEB9-AF3B8C6E1C60',
  },
  {
    name: 'Skagen Varmeværk a.m.b.a.',
    supplierId: 'B439F4BE-8A6A-4231-A2B4-9145BD3E190A',
  },
  {
    name: 'Skals Kraftvarmeværk A.m.b.a.',
    supplierId: '7881BF1E-D75E-414C-A68F-C92258034F0B',
  },
  {
    name: 'Skanderborg-Hørning Fjernvarme A.m.b.a.',
    supplierId: 'FB91926E-E079-470A-B4AA-CD7A42A233D8',
  },
  {
    name: 'Skive Fjernvarme a.m.b.a.',
    supplierId: '4FB83773-7F5D-41A3-B267-2963FC4A75FE',
  },
  {
    name: 'Skjern Fjernvarme',
    supplierId: 'CEECAE6A-4458-4065-BDA9-6704F8E34973',
  },
  {
    name: 'Skovbo Vandværk',
    supplierId: '585F3FCB-684B-4A08-9F82-92E8AEA45AD0',
  },
  {
    name: 'Skovlund Varmeværk',
    supplierId: '55ADAD5C-1AC0-4564-B9C1-12B1EEB7D3CB',
  },
  {
    name: 'Skovsgaard Varmeværk',
    supplierId: '558CEDA1-7815-4D99-863A-D27177C164B3',
  },
  {
    name: 'Skuldelev Energiselskab a.m.b.a',
    supplierId: '5E794ECC-4EE8-4C15-A2FD-9278B0CDC81B',
  },
  {
    name: 'Smørum Kraftvarme A.m.b.A.',
    supplierId: '15734B3D-987B-4DCB-A1E3-D47EF2B62A8D',
  },
  {
    name: 'Snedsted Varmeværk',
    supplierId: '30543192-5E4F-4ED9-8B7D-01A693C71F71',
  },
  {
    name: 'Softværket',
    supplierId: 'F166103F-6C24-47B3-B097-557A7CFE62BA',
  },
  {
    name: 'Solrød Fjernvarme a.m.b.a.',
    supplierId: 'BCB17A4F-2D5E-45F6-A1F3-86B6EE25A024',
  },
  {
    name: 'SONFOR VARME A/S',
    supplierId: 'EA025A06-81B4-4FAA-83CE-320CE1346BAB',
  },
  {
    name: 'Sorø Fjernvarme',
    supplierId: 'CE44A147-CE18-483B-81AF-29A188E33067',
  },
  {
    name: 'Spøttrup Varmeværk A.m.b.a',
    supplierId: '78DFE327-D817-42BB-86BE-68BD996B67F7',
  },
  {
    name: 'Spentrup Varmeværk A.m.b.a.',
    supplierId: '3E20F068-E1ED-4274-9B4D-17FFDC2DDCA1',
  },
  {
    name: 'Spjald Fjernvarme- og Vandværk',
    supplierId: 'B9B79876-4611-4549-933D-93A321AE1AEC',
  },
  {
    name: 'SSF Energi',
    supplierId: 'D10168C6-48E7-4671-8B99-80C21DC7A538',
  },
  {
    name: 'Støvring Kraftvarmeværk a.m.b.a.',
    supplierId: '6CE3BF6F-E770-4B69-823E-8F74C6C6D026',
  },
  {
    name: 'Støvring Vandværk a.m.b.a.',
    supplierId: 'A38480F3-8A9B-4A12-891C-24D574826D0A',
  },
  {
    name: 'Stege Fjernvarme A.M.B.A',
    supplierId: '25ADA1A2-EC4B-4865-8AFA-981130E33A60',
  },
  {
    name: 'Stenlille Fjernvarme',
    supplierId: '9B00381C-F2F1-4AED-ADBC-A8665871A807',
  },
  {
    name: 'Stoholm Fjernvarmeværk',
    supplierId: '841D27E7-73E6-4C14-8EB6-D7CC3B79733B',
  },
  {
    name: 'Strandby Varmeværk A.m.b.A.',
    supplierId: '52072FDB-2976-4E4F-8F08-9C363956F195',
  },
  {
    name: 'Strellev Vand',
    supplierId: 'E96471DD-16C7-469D-B5C3-5EF82336E180',
  },
  {
    name: 'Sunds Elforsyning',
    supplierId: '43840CF6-159F-430E-BB64-451B550A7325',
  },
  {
    name: 'Sunds Forsyning',
    supplierId: 'C2FC80EE-43A4-493E-A3E3-EBD9DEAD0273',
  },
  {
    name: 'Sunds Vand',
    supplierId: '121B1324-C32B-4333-89B9-8DF545DDAE5E',
  },
  {
    name: 'Sunds Varme',
    supplierId: '1455C2B9-E55A-4AAB-B2FA-8E4C460479FB',
  },
  {
    name: 'Svebølle Viskinge Fjernvarmeselskab',
    supplierId: '201AEE30-6DB6-4D61-8AED-96E75BCBD54D',
  },
  {
    name: 'Svendborg Fjernvarme a.m.b.a.',
    supplierId: '2DA3A257-1F7E-437D-9826-10AF986F40DD',
  },
  {
    name: 'Svogerslev Fjernvarme A.m.b.a',
    supplierId: 'AF8EC598-4CCC-426D-BC1E-6471908DCDB2',
  },
  {
    name: 'Sydfalster Varmeværk A.m.b.A.',
    supplierId: 'E15F5243-2845-454C-BB38-1A0F929EDB64',
  },
  {
    name: 'Sydlangeland Fjernvarme',
    supplierId: '97F2296F-B61E-42DE-B93D-1D49DA9DDAE9',
  },
  {
    name: 'Tønder Fjernvarme',
    supplierId: '36CEEFEB-02CD-466F-A697-3BD59598A117',
  },
  {
    name: 'Tørring Kraftvarmeværk',
    supplierId: '57C0A7D3-E1AA-42CF-9D83-308E566F517D',
  },
  {
    name: 'Tårnby Forsyning og Dragør Fjernvarme A/S',
    supplierId: '6753FE78-EF19-4531-8C50-62175A7EAC9E',
  },
  {
    name: 'Taars Varmeværk',
    supplierId: 'AB33DE4A-7726-4334-B428-0CB9DB248EB7',
  },
  {
    name: 'Tangsø Varmeværk',
    supplierId: '8050A37F-DBBF-43C1-9E3B-F6E5ACF2CE29',
  },
  {
    name: 'Tarm Elværk Net',
    supplierId: '6EF13C28-99CF-472A-979A-4FB3BFBECFF2',
  },
  {
    name: 'Tarm Energi a.m.b.a.',
    supplierId: 'C7F93288-041C-337C-9ECD-F6BA3E0560E3',
  },
  {
    name: 'Tarm Varmeværk A/S',
    supplierId: 'C7F93288-041C-337C-9ECD-F6BA3E0560E3',
  },
  {
    name: 'Terndrup Fjernvarme',
    supplierId: '1AA06906-BDE8-4B84-A13F-E2F87265EBCF',
  },
  {
    name: 'Thisted Varmeforsyning amba',
    supplierId: '3D6C9D52-1BB8-4718-A7A1-CE27B9D137BA',
  },
  {
    name: 'Thorsø Fjernvarmeværk',
    supplierId: '3BD6914D-1D03-4AEF-B2F9-45EA1281A394',
  },
  {
    name: 'Thorsager Fjernvarme',
    supplierId: '1F89D3C8-A933-4169-9C4B-F096ACF2FE57',
  },
  {
    name: 'Thorshøj Kraftvarme',
    supplierId: '7BD265F2-94BE-4706-8F8E-10ADCF9EC11B',
  },
  {
    name: 'Thyborøn Fjernvarme a.m.b.a.',
    supplierId: '9EC2A409-3AD2-4B40-A324-F025A034F835',
  },
  {
    name: 'Tim Fjernvarmeværk',
    supplierId: '0EF3EA2A-DA10-416F-AF1C-B36FD44393C9',
  },
  {
    name: 'Tistrup Varmeværk',
    supplierId: 'B80C4746-EF24-4C85-8198-0B55FB7A0B52',
  },
  {
    name: 'Toftlund Fjernvarme a.m.b.a.',
    supplierId: '96F94FA5-89ED-4168-8E7D-022B98DBE5C3',
  },
  {
    name: 'Tommerup Bys Fjernvarmeforsyning',
    supplierId: 'BCDB5F50-D22E-4372-9B02-5C00EF0235C5',
  },
  {
    name: 'Tommerup Station Varmeforsyning',
    supplierId: '053B5BFF-675D-4D40-8BBF-5321D7578D49',
  },
  {
    name: 'Torslev Vand',
    supplierId: 'AF3E2FDE-903C-40B7-A1FA-57AFB08413E6',
  },
  {
    name: 'Træden-Gammelstrup Vandværk',
    supplierId: '0908DEB3-448E-401C-BFD2-557883C9B045',
  },
  {
    name: 'Tranbjerg Varmeværk',
    supplierId: '28F1A7D8-AF10-4ECD-B7F6-3E64EB89FD3C',
  },
  {
    name: 'Tranegilde Fjernvarme',
    supplierId: '2C060181-E4F0-45F8-91EF-EDED40C88EDE',
  },
  {
    name: 'Tranum Varmeværk',
    supplierId: '87FA52ED-6694-4D09-867D-007BD98A1C76',
  },
  {
    name: 'Troldhede Kraftvarmeværk',
    supplierId: '3A373BB7-4E26-4A97-96FC-F9EFF6F19F8B',
  },
  {
    name: 'Trustrup Lyngby Vandværk / Trustrup Lyngby Varmeværk',
    supplierId: '6D41BB37-CDD5-45ED-8E49-E81C97804BE0',
  },
  {
    name: 'Trustrup-Lyngby Nærvarmeværk',
    supplierId: 'F47C7896-8346-4A6E-ABEB-E940CE24D20C',
  },
  {
    name: 'Trustrup-Lyngby TLV-Forsyning',
    supplierId: 'EDFC41D1-FD4A-431A-A7D5-E3CEF61535E9',
  },
  {
    name: 'Tversted Kraftvarmeværk',
    supplierId: '3EF98813-14D4-4CEB-8A21-E2BDB3578DDC',
  },
  {
    name: 'Ulfborg Fjernvarme a.m.b.a',
    supplierId: '382D97E7-8C4B-4C63-991F-BB20B3E51263',
  },
  {
    name: 'Ullits Vand',
    supplierId: 'A974F061-37FD-4D2C-9445-A96217712AC0',
  },
  {
    name: 'Ulsted Varmeværk',
    supplierId: '4349789E-CC41-47C4-B74A-95DD5E9A2A01',
  },
  {
    name: 'Værløse Varmeværk',
    supplierId: 'C3FFBD4F-139B-4F4B-A243-478C7B1DCE5A',
  },
  {
    name: 'Værum-Ørum Kraftvarmeværk',
    supplierId: '5D93075F-4ABF-4FA3-BE8F-126CD269C957',
  },
  {
    name: 'Vaarst-Fjellrad KV',
    supplierId: '5D689004-A42C-4030-91E0-A8DCB336E5AB',
  },
  {
    name: 'Vallensbæk Fjernvarme Nord',
    supplierId: '4B56D0DB-160C-4D5E-A00A-9A4E35AF7B12',
  },
  {
    name: 'Vallensbæk Fjernvarme Syd',
    supplierId: '8953CF1B-C446-4168-BD00-E683A9BCA9A2',
  },
  {
    name: 'Vamdrup Fjernvarme',
    supplierId: '168773A5-923A-4DC8-A067-76EE92C32DAC',
  },
  {
    name: 'Veddum-Skelund-Visborg Kraftvarmeværk',
    supplierId: '0EC1B9CE-D0E4-4537-B8DC-5FEDB2BAD45E',
  },
  {
    name: 'Vejby-Tisvilde Fjernvarme A.m.b.a.',
    supplierId: '482B94CC-8A68-4344-8C40-6708012FF996',
  },
  {
    name: 'Vejen Varmeværk',
    supplierId: '70972368-A45E-4D20-B24F-06FD41B22863',
  },
  {
    name: 'Vejle Fjernvarme a.m.b.a.',
    supplierId: 'fdb50fd7-7260-4f99-b1fe-bc67aa85197e',
  },
  {
    name: 'Vemb Varmeværk',
    supplierId: '4C358707-2A81-4AF1-93D8-8065D86651D2',
  },
  {
    name: 'Vester Hjermitslev Varmeværk',
    supplierId: 'BE3B9819-3CA9-47F5-AB8F-9915189CA847',
  },
  {
    name: 'Vestervig Fjernvarme a.m.b.a.',
    supplierId: 'A61DA078-0A34-47D1-866E-0110137F0D6D',
  },
  {
    name: 'Vestervig Vand',
    supplierId: 'AE7FF281-6293-4C4B-991B-63526A30C803',
  },
  {
    name: 'Vestforbrænding',
    supplierId: 'C3FFBD4F-139B-4F4B-A243-478C7B1DCE5A',
  },
  {
    name: 'Viborg Varme',
    supplierId: '074B5C36-0756-4BFF-A6F3-E694532776BA',
  },
  {
    name: 'Videbæk Elnet A/S',
    supplierId: '8C963645-1577-4D71-A67E-352075DB7411',
  },
  {
    name: 'Videbæk Energiforsyning A.m.b.a.',
    supplierId: 'A2520C6C-2C53-4EF4-B6C0-781ACBA8C986',
  },
  {
    name: 'Videbæk Energiforsyning A/S',
    supplierId: 'A77A8E03-05A3-44BA-9578-63518163F395',
  },
  {
    name: 'Videbæk Vand A/S',
    supplierId: 'AA41E918-CB5B-40FF-AD81-B0408BAF5DF6',
  },
  {
    name: 'Videbæk Varme A/S',
    supplierId: 'C2B7430D-57AA-41D5-BA4F-6EFAC9340CB4',
  },
  {
    name: 'Vildbjerg Vand A/S',
    supplierId: '1048A396-C690-4BB3-9C33-1CB7E63015EE',
  },
  {
    name: 'Vildbjerg Varme A/S',
    supplierId: 'A931B607-13BB-4306-AEB2-619B7DCEC992',
  },
  {
    name: 'Vinderup Varmeværk',
    supplierId: 'C0584E30-4F38-4774-B32E-7F6E6AFCCA35',
  },
  {
    name: 'Vivild Varmeværk',
    supplierId: '024AC587-33CD-438D-8329-CE449A07C806',
  },
  {
    name: 'Voerladegaard Vandværk',
    supplierId: '340A16BA-9EB3-46DF-8870-9FA09F5B9E51',
  },
  {
    name: 'Voerså Kraftvarmeværk',
    supplierId: '4C479436-A295-4E0F-AFF7-CB245B07423F',
  },
  {
    name: 'Voervadsbro Vandværk',
    supplierId: '85EFDBD8-6525-4ECD-BA77-F95604F4249B',
  },
  {
    name: 'Vojens Fjernvarme a.m.b.a.',
    supplierId: '17723E52-8DF9-4BB9-9FA2-44FB9130AFF5',
  },
  {
    name: 'Vonsild Vandværk',
    supplierId: '88CB3749-76BD-442D-8FDC-7ED8BF2BE4C8',
  },
  {
    name: 'Vordingborg Energi Holding A/S',
    supplierId: '9BEFE9A4-CD6D-4305-9067-91324BA0E929',
  },
  {
    name: 'Vordingborg Fjernvarme',
    supplierId: '95203D08-26BD-4E75-AA8C-9FD87B3D1B02',
  },
  {
    name: 'Vordingborg Forsyningsservice A/S',
    supplierId: 'a72f06ae-ca2d-469a-ab37-b1036984dacd',
  },
  {
    name: 'Vordingborg Kraftvarme',
    supplierId: 'A72F06AE-CA2D-469A-AB37-B1036984DACD',
  },
  {
    name: 'Vordingborg Rens',
    supplierId: '4116CCDC-9E56-4BD9-B948-BB38E4FBCC1F',
  },
  {
    name: 'Vordingborg Spildevand',
    supplierId: 'B447E970-7E97-4531-9AEA-B8C187514B9A',
  },
  {
    name: 'Vordingborg Vand',
    supplierId: 'ACDABB4A-92CD-4E00-BEFB-CDC6C57B1082',
  },
  {
    name: 'Vorupør Kraftvarmeværk',
    supplierId: '5A4E63BC-A044-4FC3-A46E-C51FBD420D55',
  },
  {
    name: 'Vrå Varmeværk a.m.b.a',
    supplierId: '84B22C9D-D752-48EF-B675-C6BCF6942D46',
  },
] satisfies SupplierOption[];
